import { CarSimple, Motorcycle, Truck } from "@phosphor-icons/react";

export const VEHICLE_TYPES = [
  { value: "car", label: "Car", icon: CarSimple },
  { value: "bike", label: "Bike", icon: Motorcycle },
  { value: "truck", label: "Truck", icon: Truck },
];

export const VEHICLE_STATUSES = ["available", "reserved", "sold", "sold_by_ad", "registered"];

export const PAYMENT_METHODS = ["cash", "card", "finance", "lease"];
export const TENDER_METHODS = ["cash", "upi", "online", "card", "platform"]; // mixed-tender lines on a sale
export const SALE_TYPES = [
  { value: "cash", label: "Cash" },
  { value: "exchange", label: "Exchange" },
  { value: "finance", label: "Finance" },
];

export const SAMPLE_IMAGES = {
  car: "https://images.pexels.com/photos/17744273/pexels-photo-17744273.jpeg",
  bike: "https://images.unsplash.com/photo-1609630875171-b1321377ee65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlfGVufDB8fHx8MTc4MTUwOTk4MHww&ixlib=rb-4.1.0&q=85",
  truck:
    "https://images.unsplash.com/photo-1601467995997-ac1ae9a8fff4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwdHJ1Y2slMjBzdHVkaW8lMjBzaG90fGVufDB8fHx8MTc4MTUwOTk3MXww&ixlib=rb-4.1.0&q=85",
};

export const STATUS_BADGE_MAP = {
  available: { dot: "bg-[#00B341]", label: "Available" },
  reserved: { dot: "bg-[#FFD700]", label: "Reserved" },
  sold: { dot: "bg-[#FF2A2A]", label: "Sold" },
  sold_by_ad: { dot: "bg-[#7B2CBF]", label: "Sold by AD" },
  registered: { dot: "bg-[#002FA7]", label: "Registered" },
};

export const CHART_TOOLTIP_STYLE = {
  borderRadius: 0,
  border: "1px solid #0A0A0A",
  fontFamily: "IBM Plex Mono",
  fontSize: 12,
};

export const CHART_DOT_STYLE = { r: 3, fill: "#002FA7" };

export const TOAST_OPTIONS = {
  style: {
    borderRadius: 0,
    border: "1px solid #0A0A0A",
    fontFamily: "Work Sans, system-ui, sans-serif",
  },
};

export const EMPTY_VEHICLE_FORM = {
  type: "car",
  year: new Date().getFullYear(),
  vin: "",
  price: "",
  color: "",
  mileage: 0,
  image_url: "",
  status: "available",
  notes: "",
  package_ids: [],
  branch_id: "",
};

export const LEAD_STATUSES = [
  { value: "new", label: "New", color: "#5C5C5C" },
  { value: "contacted", label: "Contacted", color: "#002FA7" },
  { value: "test_drive", label: "Test Drive", color: "#0088CC" },
  { value: "quote", label: "Quote Sent", color: "#FF8C00" },
  { value: "won", label: "Won", color: "#00B341" },
  { value: "lost", label: "Lost", color: "#FF2A2A" },
];

export const NOTE_TYPES = [
  { value: "note", label: "Note" },
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
  { value: "sms", label: "SMS" },
  { value: "visit", label: "Visit" },
];

export const EMPTY_CUSTOMER_FORM = {
  // Identity
  name: "",
  first_name: "",
  last_name: "",
  relation_type: "",
  relation_name: "",
  gender: "",
  dob: "",
  // Contact
  email: "",
  phone: "",
  alternate_phone: "",
  // Structured address
  house_no: "",
  street: "",
  town_village: "",
  mandal: "",
  district: "",
  state: "",
  pin_code: "",
  country: "India",
  address: "",
  // KYC
  aadhar_no: "",
  pan_no: "",
  driving_licence_no: "",
  // Customer type
  customer_type: "direct",  // "direct" (B2C) | "business" (B2B)
  gst_number: "",  // mandatory when customer_type === "business"
  // Meta
  notes: "",
  documents: [],
  branch_id: "",
};

export const EMPTY_SALE_FORM = {
  vehicle_id: "",
  customer_id: "",
  // Capability flags — cash is always implied. Either or both can be enabled.
  has_exchange: false,
  has_finance: false,
  on_road_price: "",
  advance_amount: 0,
  down_payment: 0,
  sales_agent_id: "",
  discount: 0,
  sale_price: "",
  payment_lines: [],
  exchange: null,
  finance: null,
  notes: "",
  package_ids: [],
  package_item_exclusions: {},
  gst_type: "intra",
  branch_id: "",
};

export const EMPTY_EXCHANGE = {
  description: "",
  year: "",
  registration_no: "",
  color: "",
  amount: 0,
  evaluator_id: "",
  notes: "",
};

export const EMPTY_FINANCE = {
  financier_id: "",
  finance_amount: 0,
  do_number: "",
  commission_amount: 0,
  finance_type: "loan",
};
